import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AskResult } from 'src/app/components/support-popup/models/AskResult';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class AskApiService {

    private readonly baseUrl = environment.SUPPORT_BASE_URL;

    constructor(private http: HttpClient) { }

    public getResult(query: string): Observable<AskResult> {
        const lang = 'no';
        const version = '2'
        const url = `${this.baseUrl}/ask?question=${encodeURIComponent(query)}&version=${version}&lang=${lang}`;

        return this.http.get<any>(url).pipe(
            map(res => {
                const askResult = new AskResult();
                askResult.answer = res.data?.answer || '';
                askResult.listOfArticles = res.data?.listOfArticles || [];
                askResult.listOfArticleIds = res.data?.listOfArticleIds || [];
                return askResult;
            })
        );
    }
}
